export var SDK_VERSION = '6.10.0';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@sentry/core/esm/version.js
// module id = 778
// module chunks = 81